export const LOCALES_WITH_REGION = ['en-US', 'da-dk', 'de-de', 'pl-PL'];
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_CHINA_LOCALE = 'zh-CN';
export const DEFAULT_SC_LOCALE = 'en';
